export class BeforeAfter {
  constructor() {
    this.instances = document.querySelectorAll(".s-before-after");

    if (this.instances.length) {
      this.instances.forEach((instance) => {
        this.initInstance(instance);
      });
    }
  }

  initInstance(container) {
    const cursor = container.querySelector(".s-before-after-cursor");
    const imagesContainer = container.querySelector(".s-before-after-images");
    const beforeImage = container.querySelector(
      ".s-before-after-images .c-image.before"
    );
    const afterImage = container.querySelector(
      ".s-before-after-images .c-image.after"
    );

    if (!cursor || !imagesContainer || !beforeImage || !afterImage) {
      return;
    }

    let isDragging = false;
    let currentPosition = 50;

    this.updatePosition(container, cursor, afterImage, currentPosition);

    cursor.addEventListener("mousedown", (e) => {
      isDragging = true;
      e.preventDefault();
    });

    document.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      this.handleMove(e, container, cursor, afterImage, imagesContainer);
    });

    document.addEventListener("mouseup", () => {
      if (isDragging) {
        isDragging = false;
      }
    });

    cursor.addEventListener("touchstart", (e) => {
      isDragging = true;
      e.preventDefault();
    });

    document.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      const touch = e.touches[0];
      this.handleMove(touch, container, cursor, afterImage, imagesContainer);
    });

    document.addEventListener("touchend", () => {
      isDragging = false;
    });

    imagesContainer.addEventListener("click", (e) => {
      if (!isDragging) {
        this.handleMove(e, container, cursor, afterImage, imagesContainer);
      }
    });
  }

  handleMove(event, container, cursor, afterImage, imagesContainer) {
    const rect = imagesContainer.getBoundingClientRect();
    const x = event.clientX || event.pageX;
    const position = ((x - rect.left) / rect.width) * 100;
    const clampedPosition = Math.max(0, Math.min(100, position));

    this.updatePosition(container, cursor, afterImage, clampedPosition);
  }

  updatePosition(container, cursor, afterImage, position) {
    cursor.style.left = `${position}%`;
    cursor.style.transform = "translateX(-50%)";

    afterImage.style.clipPath = `inset(0 ${100 - position}% 0 0)`;
  }
}
